import { useMutation, useQueryClient } from '@tanstack/react-query';

import { inclusionsQueryKeys } from '~/hooks/apis/inclusions/inclusionsQueryKeys';

import InclusionsService from '~/services/InclusionsService';
import PackagesService from '~/services/PackagesService';

import type { PackageInclusionMutationPayload } from '../inclusions/packageInclusionMutationUtils';

export interface SaveOfferPackageParams {
  offerId: string;
  packageData: Record<string, unknown>;
  packageId: string;
  packageInclusions: Array<PackageInclusionMutationPayload>;
}

export function useSaveOfferPackage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ offerId, packageData, packageId, packageInclusions }: SaveOfferPackageParams) => {
      // Matches legacy PackageForm: inclusion and package saves are separate calls, so this is not atomic.
      await InclusionsService.updatePackageInclusion({
        package_inclusions: packageInclusions,
      });

      return PackagesService.updatePackage(packageData, offerId, packageId);
    },
    onSuccess: (_data, variables) =>
      queryClient.invalidateQueries({ queryKey: inclusionsQueryKeys.packageInclusionsByOffer(variables.offerId) }),
  });
}
